import httpClient from "./httpClient";

/**
 * Best-effort client activity (SPA route). Server uses optionalAuth + CDN country headers.
 * @param {{ path: string; title?: string; referrer?: string; anonKey?: string }} body
 */
export function postActivityLog(body) {
  return httpClient.post("/activity/log", body);
}
